import * as React from 'react'

import {Button, Form, Input, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import commonStyles from '../../../src/styles/common.scss';
import {BASE_PATH} from "../../../src/swagger";
import appStyles from '../../assets/css/app.scss';
import {action, observable, runInAction} from "mobx";
import portableFetch from "portable-fetch";
import {BaseValidations} from "../../../src/utils/form/validate/BaseValidations";
import {getQueryParam} from "../../../src/utils/react/routerUtil";
import KixGbcMemberSimpleLayout from "../../layouts/KixGbcMemberSimpleLayout/KixGbcMemberSimpleLayout";
import {redirect} from "../../../src/common/Router/routerCommon";

const FormItem = Form.Item;

@observer
class PasswordResetExec extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  @observable
  sended = false;

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  @action
  handleSubmit = () => {
    this.formUtils.validateFields((err, _values: any) => {
      if (!err) {
        let bodyObj = {
          reset_token: getQueryParam("token") as string,
          pass: this.formUtils.getFieldValue("password"),
        };
        const method = "POST";
        const body = JSON.stringify(bodyObj);
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        portableFetch(BASE_PATH + "/kix_gbc/password_reset_exec", {
          method,
          headers,
          body,
          credentials: "include"
        }).then(async (res: any) => {
          let json = await res.json();
          runInAction(() => {
            if (json.result.code == 1) {
              this.sended = true;
            } else {
              message.error(json.result.message);
            }
          });
        }).catch(() => {
          message.error("通信に失敗しました。もう一度お試し下さい。");
        });
      }
    });
  };

  @action
  validatePass = (_rule: any, value: string, callback: (error?: string) => void): void => {
    if (/[0-9]+/.test(value) && /[a-z]+/.test(value) && /[A-Z]+/.test(value)) {
      callback();
    } else {
      callback("パスワードは８文字以上、半角英字小文字、半角英字大文字、数字を全て含めて入力してください。");
    }
  };

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <><KixGbcMemberSimpleLayout notLogout={true}>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>パスワード再設定</h2>

        {!this.sended ?
          <>
            <p style={{color: "white"}}>パスワードを再設定するには、新しいパスワードを入力して
              “送信”ボタンをクリックしてください。
            </p>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>パスワード</span>
            <FormItem>
              {getFieldDecorator('password', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.minLen(8),
                  BaseValidations.maxLen(64),
                  {validator: (_rule: any, value: string, cb: (error?: string) => void) => this.validatePass(_rule, value, cb)},
                ],
              })(
                <Input size="large" type={"password"}
                       name="password"
                       autoComplete="off"
                       placeholder="パスワード" onBlur={() => this.formUtils.setFieldsValue({"password_confirm": this.formUtils.getFieldValue("password_confirm")})}/>
              )}
            </FormItem>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>パスワード(確認用)</span>
            <FormItem>
              {getFieldDecorator('password_confirm', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.sameWith(this.formUtils),
                ],
              })(
                <Input size="large" type={"password"}
                       name="password_confirm"
                       autoComplete="off"
                       placeholder="パスワード(確認用)"/>
              )}
            </FormItem>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={this.handleSubmit}
                >
                  送信
                </Button>
              </FormItem>
            </div>
          </> : <>
            <p style={{color: "white", fontWeight:"bold"}}>
              パスワードの再設定が完了しました。
            </p>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={() => redirect("/")}
                >
                  戻る
                </Button>
              </FormItem>
            </div>
          </>
        }
      </KixGbcMemberSimpleLayout>
      </>
    );
  }
}

export default Form.create()(PasswordResetExec)

